// extracted by mini-css-extract-plugin
export default {"mainStyleLogo":"LogoText_mainStyleLogo__twZ6q","logoSpan":"LogoText_logoSpan__XJbdY"};